import React, { useEffect, useState } from "react";
import { useMutation } from "react-query";
import { useHistory } from "react-router";

import { OrderCsvUploadV2 as OrderCsvUpload } from "@secondcloset/web-components";

import { Modal } from "antd";

import { fetchAndDownloadCsvTemplate } from "api/fulfillment/downloadCSV";

import { useFacilityIndex } from "../../../hooks/api/common/useFacilityIndex";
import { useUploadOrderMutation } from "../../../hooks/mutation/useUploadOrderCSV";

interface OrderCsvUploadV2Prop {
  pageRef: React.RefObject<HTMLDivElement>;
  organizationId: string;
}

export const OrderCsvUploadV2: React.FC<OrderCsvUploadV2Prop> = ({ pageRef, organizationId }) => {
  const [orderDetailsCsvFile, setOrderDetailsCsvFile] = useState<File>();
  const [orderItemsCsvFile, setOrderItemsCsvFile] = useState<File>();
  const { mutate: fetchCSVTemplate } = useMutation(fetchAndDownloadCsvTemplate);
  const history = useHistory();
  const facilityIndex = useFacilityIndex();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const { mutate, ...uploadStatus } = useUploadOrderMutation({
    onSuccess: ({ message }) => {
      if (message) {
        Modal.info({
          title: "Order CSV Upload In Progress",
          content: message,
          onOk: () => history.push(`/organizations/${organizationId}/orders`),
        });
      } else {
        history.push(`/organizations/${organizationId}/orders`);
      }
    },
  });
  const handleOnSubmit = () => {
    if (orderDetailsCsvFile && orderItemsCsvFile && organizationId) {
      mutate({
        organization_id: organizationId,
        orderDetailsCSV: orderDetailsCsvFile,
        orderItemsCSV: orderItemsCsvFile,
      });
    }
  };

  return (
    <OrderCsvUpload
      orderDetailsCsvFile={orderDetailsCsvFile}
      setOrderDetailsCsvFile={setOrderDetailsCsvFile}
      orderItemsCsvFile={orderItemsCsvFile}
      setOrderItemsCsvFile={setOrderItemsCsvFile}
      onDownloadOrderDetailsTemplate={() => {
        pageRef.current && fetchCSVTemplate({ key: "fulfillment_create_order_details", node: pageRef.current });
      }}
      onDownloadOrderItemsTemplate={() => {
        pageRef.current && fetchCSVTemplate({ key: "fulfillment_create_order_items", node: pageRef.current });
      }}
      onSubmit={handleOnSubmit}
      isSubmitLoading={uploadStatus.isLoading}
      submitError={uploadStatus?.error?.errors}
      facilities={facilityIndex.data || []}
      organizationId={organizationId}
    />
  );
};
